import infinityScroll from "./infinityScroll.js";
import sidebar from "./sidebar.js";
import carousel from "./carousel.js";
import searchSelect from "./searchSelect.js";
import aiResponse from "./aiResponse.js";
import multiSelect from "./multiSelect.js";
import reorderable from "./reorderable.js";
import richText from "./richText/index.js";
import userInviteSelect from "./userInviteSelect.js";
import chart from "./chart.js";

Alpine.data('infinityScroll', infinityScroll);
Alpine.data('sidebar', sidebar);
Alpine.data('carousel', carousel);
Alpine.data('searchSelect', searchSelect);
Alpine.data('AiResponse', aiResponse);
Alpine.data('multiSelect', multiSelect);
Alpine.data('reorderable', reorderable);
Alpine.data('richText', richText);
Alpine.data('userInviteSelect', userInviteSelect);
Alpine.data('chart', chart);

